// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"ad341c63","239":"b143cd0e","355":"a970c638","453":"c89e67f6","713":"f83cbcc3","732":"0873bbda","853":"d9c2075e","977":"372fbe9f"}[chunkId] + ".chunk.js";
};